import { TransactionSuccessToast } from "@/components";
import { TOKEN_IDS, type TransactionHash } from "@/types";
import { ToastDetailRow } from "@/components";

interface ClaimSuccessToastProps {
    claimAmount: number;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function ClaimSuccessToast({ claimAmount, transactionHash, onClose }: ClaimSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Claim successful" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Claimed" amount={claimAmount} tokenId={TOKEN_IDS.USDC} />
        </TransactionSuccessToast>
    );
}
